export const SET_CITIZENS="app/citizensList/SET_CITIZENS"
